<template>
  <div>
    <div class="cop_title">
      <i
        class="iconfont icon-fanhui icon"
        @click="CompareShow"
        :style="{
          color: $store.state.app.searchType == 'risk' ? '#685ED1' : '#1296db',
        }"
      ></i>
      <!-- <img src="../../assets/img/detail/title_ic17.png" /> -->
      {{ $t("Profile.CompareCompanies") }}
    </div>

    <div class="cop_cont_box">
      <div class="cop_cont_cont flex_box">
        <div
          class="list title list-title"
          style="border-right: 1px solid #e7eaed"
        >
          <div class="item item_active">{{ $t("Profile.CompanyName") }}:</div>
          <div class="item">{{ $t("Profile.NativeName") }} :</div>
          <div class="item">{{ $t("Profile.LegalStatus") }}:</div>
          <div class="item">{{ $t("Profile.LegalForm") }}:</div>
          <div class="item">{{ $t("IndustryNorms.YearsinBusiness") }}:</div>
          <div class="item">{{ $t("Profile.RegisteredCapital") }}:</div>
          <div class="item">{{ $t("Industry.ISIC") }}:</div>
          <div class="item">{{ $t("Industry.ISICDescription") }}:</div>
          <div class="item">{{ $t("Snapshot.Listed") }}:</div>
          <div class="item">{{ $t("Snapshot.NoofEmployees") }}</div>
          <div class="item">{{ $t("Snapshot.NoofShareholders") }}:</div>
          <div class="item">{{ $t("IndustryNorms.Revenue") }}:</div>
          <div class="item">Net Income:</div>
          <div class="item">{{ $t("IndustryNorms.TotalAssets") }}:</div>
          <div class="item">Profit margin:</div>
          <div class="item">{{ $t("IndustryStatistics.Profitability") }}:</div>
          <div class="item">Compliance Risk:</div>
          <div class="item">{{ $t("CreditOpinion.LocalCreditScore") }}:</div>
          <!-- <div class="item" v-show="lastView || lastView3"></div> -->
        </div>
        <div
          class="list content list contentone"
          style="border-right: 1px solid #e7eaed"
        >
          <div class="item item_active">
            <div
              class="Deletepostionleft"
              :style="{
                'background-color': $store.state.app.themeColor,
              }"
            >
              <svg
                t="1730875056113"
                class="icon"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="5985"
                width="20"
                height="20"
              >
                <path
                  d="M990.73312 306.653c-2.624-2.624-254.57-254.32-279.19-278.44-0.875-0.875-1.625-1.625-2.625-2.375-45.74-37.242-111.6-33.868-153.217 7.874-35.242 35.117-33.243 82.232-31.993 112.85 0.125 7.874 0.375 15.997 0.375 23.495 0 32.618-30.744 79.858-78.233 120.35-49.615 42.366-106.728 68.235-139.096 62.986-7.623-1.25-14.622-1.874-20.87-2.374-3-0.25-5.624-0.5-8.248-0.75-152.718-37.867-221.453 62.362-229.451 74.984-11.623 20.246-8.499 45.74 7.873 61.987l166.964 166.964-212.97 288.313c-15.122 20.246-12.997 48.115 5.124 66.361 9.998 9.998 22.995 15.122 35.992 15.122 10.498 0 20.996-3.25 29.869-9.998L372.35012 803.547l164.964 164.965c16.622 16.621 42.366 19.746 62.987 7.248 11.498-7.248 111.476-75.484 74.61-225.077-0.376-2.5-2.5-20.62-3.625-30.868-2.625-31.993 28.619-103.353 79.358-158.591 35.992-39.117 72.86-60.737 103.728-60.737 7.498 0 15.621 0.125 22.995 0.375 31.243 1.374 78.483 3.374 113.6-31.743 21.62-21.62 33.618-50.365 33.493-81.108-0.109-30.744-11.997-59.612-33.727-81.358z"
                  fill="#FFFFFF"
                  p-id="5986"
                ></path>
              </svg>
              {{ $t("RatingAnalysis.SubjectCompany") }}
            </div>
            <div
              class="line_2"
              @click="setidtwo(compObj)"
              style="font-family: 'Arial Bold'; cursor: pointer"
            >
              {{ compObj.CompanyName }}
            </div>
          </div>
          <div class="item">
            <div class="line_2">{{ compObj.CompanyNativeName }}</div>
          </div>
          <div class="item">
            <div class="line_2">
              <div class="line_2">{{ compObj.status }}</div>
            </div>
          </div>
          <div class="item">
            <div class="line_2">{{ compObj.LegalForm }}</div>
          </div>
          <div class="item">
            <div class="line_2">{{ compObj.YearsinBusiness }}</div>
          </div>
          <div class="item">
            <div class="line_2">{{ compObj.RegCapital }}</div>
          </div>
          <div class="item">
            <div class="line_2">{{ compObj.isic }}</div>
          </div>
          <div class="item">
            <div class="line_2">{{ compObj.IndustryDescription }}</div>
          </div>
          <div class="item">
            <div class="line_2">{{ compObj.Listed }}</div>
          </div>
          <div class="item">
            <div class="line_2">{{ compObj.NoofEmployees }}</div>
          </div>
          <div class="item">
            <div class="line_2">{{ compObj.Noofshareholders }}</div>
          </div>
          <div class="item">
            <div class="line_2">{{ compObj.Revenue }}</div>
          </div>
          <div class="item">
            <div class="line_2">{{ compObj.Netincome }}</div>
          </div>
          <div class="item">
            <div class="line_2">{{ compObj.TotalAssets }}</div>
          </div>
          <div class="item">
            <div class="line_2">{{ compObj.Profitmargin }}</div>
          </div>
          <div class="item">
            <div class="line_2">{{ compObj.Profitability }}</div>
          </div>
          <div class="item">
            <div class="line_2">{{ compObj.BlackList }}</div>
          </div>
          <div class="item">
            <div class="line_2">{{ compObj.CreditScore }}</div>
          </div>
          <!-- <div class="item" v-show="lastView || lastView3"></div> -->
        </div>
        <div class="list content" style="border-right: 1px solid #e7eaed">
          <div class="item item_active">
            <div class="Deletepostionleft">
              <svg
                t="1730875056113"
                class="icon"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="5985"
                width="20"
                height="20"
              >
                <path
                  d="M990.73312 306.653c-2.624-2.624-254.57-254.32-279.19-278.44-0.875-0.875-1.625-1.625-2.625-2.375-45.74-37.242-111.6-33.868-153.217 7.874-35.242 35.117-33.243 82.232-31.993 112.85 0.125 7.874 0.375 15.997 0.375 23.495 0 32.618-30.744 79.858-78.233 120.35-49.615 42.366-106.728 68.235-139.096 62.986-7.623-1.25-14.622-1.874-20.87-2.374-3-0.25-5.624-0.5-8.248-0.75-152.718-37.867-221.453 62.362-229.451 74.984-11.623 20.246-8.499 45.74 7.873 61.987l166.964 166.964-212.97 288.313c-15.122 20.246-12.997 48.115 5.124 66.361 9.998 9.998 22.995 15.122 35.992 15.122 10.498 0 20.996-3.25 29.869-9.998L372.35012 803.547l164.964 164.965c16.622 16.621 42.366 19.746 62.987 7.248 11.498-7.248 111.476-75.484 74.61-225.077-0.376-2.5-2.5-20.62-3.625-30.868-2.625-31.993 28.619-103.353 79.358-158.591 35.992-39.117 72.86-60.737 103.728-60.737 7.498 0 15.621 0.125 22.995 0.375 31.243 1.374 78.483 3.374 113.6-31.743 21.62-21.62 33.618-50.365 33.493-81.108-0.109-30.744-11.997-59.612-33.727-81.358z"
                  fill="#FFFFFF"
                  p-id="5986"
                ></path>
              </svg>
              {{ $t("RatingAnalysis.SubjectCompany") }}
            </div>
            <div
              class="flex_center Deletepostion"
              v-show="!isDelOne"
              style="color: #1a2332"
              @click="(addIndex = 2), delCompany()"
            >
              <!-- <i class="cop_del_ic"></i> -->
              <svg
                t="1730875902586"
                class="icon"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="6280"
                width="20"
                height="20"
              >
                <path
                  d="M547.4 512l278.2-278.2c9.8-9.8 9.8-25.6 0-35.4-9.8-9.8-25.6-9.8-35.4 0L512 476.6 233.8 198.4c-9.8-9.8-25.6-9.8-35.4 0-9.8 9.8-9.8 25.6 0 35.4L476.6 512 198.4 790.2c-9.8 9.8-9.8 25.6 0 35.4 4.9 4.9 11.3 7.3 17.7 7.3s12.8-2.4 17.7-7.3L512 547.4l278.2 278.2c4.9 4.9 11.3 7.3 17.7 7.3s12.8-2.4 17.7-7.3c9.8-9.8 9.8-25.6 0-35.4L547.4 512z"
                  fill="#1A2332"
                  p-id="6281"
                ></path>
              </svg>
            </div>
            <div class="cop_add">
              <div
                class="flex_center CompanyNameActive"
                v-show="isDelOne"
                @click="(addIndex = 2), Add()"
              >
                <!-- <i class="cop_add_ic"></i> -->
                <svg
                  t="1725586885335"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="5401"
                  width="20"
                  height="20"
                >
                  <path
                    d="M995.84 483.84H540.16V28.16a28.16 28.16 0 1 0-56.32 0v455.68H28.16a28.16 28.16 0 0 0 0 56.32h455.68v455.68a28.16 28.16 0 1 0 56.32 0V540.16h455.68a28.16 28.16 0 1 0 0-56.32z"
                    p-id="5402"
                    fill="#1290C9"
                  ></path>
                </svg>
                {{ $t("Profile.AddaCompany") }}
              </div>
            </div>
            <div
              class="line_2"
              style="font-family: 'Arial Bold'; cursor: pointer"
              @click="setidtwo(compObj2)"
            >
              {{ compObj2.CompanyName }}
            </div>
          </div>
          <div class="item">
            <div class="line_2">{{ compObj2.CompanyNativeName }}</div>
          </div>
          <div class="item">
            <div class="line_2">
              {{ compObj2.status }}
            </div>
          </div>
          <div class="item">
            <div class="line_2">{{ compObj2.LegalForm }}</div>
          </div>
          <div class="item">
            <div class="line_2">{{ compObj2.YearsinBusiness }}</div>
          </div>
          <div class="item">
            <div class="line_2">{{ compObj2.RegCapital }}</div>
          </div>
          <div class="item">
            <div class="line_2">{{ compObj2.isic }}</div>
          </div>
          <div class="item">
            <div class="line_2">{{ compObj2.IndustryDescription }}</div>
          </div>
          <div class="item">
            <div class="line_2">{{ compObj2.Listed }}</div>
          </div>
          <div class="item">
            <div class="line_2">{{ compObj2.NoofEmployees }}</div>
          </div>
          <div class="item">
            <div class="line_2">{{ compObj2.Noofshareholders }}</div>
          </div>
          <div class="item">
            <div class="line_2">{{ compObj2.Revenue }}</div>
          </div>
          <div class="item">
            <div class="line_2">{{ compObj2.Netincome }}</div>
          </div>
          <div class="item">
            <div class="line_2">{{ compObj2.TotalAssets }}</div>
          </div>
          <div class="item">
            <div class="line_2">{{ compObj2.Profitmargin }}</div>
          </div>
          <div class="item">
            <div class="line_2">{{ compObj2.Profitability }}</div>
          </div>
          <div class="item">
            <div class="line_2">{{ compObj2.BlackList }}</div>
          </div>
          <div class="item">
            <div class="line_2">{{ compObj2.CreditScore }}</div>
          </div>
          <!-- <div class="item" v-show="lastView">
            <button class="btn_view" @click="ViewDetails(2)">
              View Details
            </button>
            <el-tooltip
              v-if="updateDisabled"
              content="It normally takes 2-4 days to deliver,this updated rerpot."
              :visible-arrow="false"
              placement="top"
              effect="light"
            >
              <button class="btn_gray">In Production...</button>
            </el-tooltip>
            <button class="btn_view" v-else @click="getPDFFile(2)">
              Order Update Report
            </button>
          </div> -->
        </div>
        <div class="list content">
          <div class="item item_active">
            <div class="Deletepostionleft">
              <svg
                t="1730875056113"
                class="icon"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="5985"
                width="20"
                height="20"
              >
                <path
                  d="M990.73312 306.653c-2.624-2.624-254.57-254.32-279.19-278.44-0.875-0.875-1.625-1.625-2.625-2.375-45.74-37.242-111.6-33.868-153.217 7.874-35.242 35.117-33.243 82.232-31.993 112.85 0.125 7.874 0.375 15.997 0.375 23.495 0 32.618-30.744 79.858-78.233 120.35-49.615 42.366-106.728 68.235-139.096 62.986-7.623-1.25-14.622-1.874-20.87-2.374-3-0.25-5.624-0.5-8.248-0.75-152.718-37.867-221.453 62.362-229.451 74.984-11.623 20.246-8.499 45.74 7.873 61.987l166.964 166.964-212.97 288.313c-15.122 20.246-12.997 48.115 5.124 66.361 9.998 9.998 22.995 15.122 35.992 15.122 10.498 0 20.996-3.25 29.869-9.998L372.35012 803.547l164.964 164.965c16.622 16.621 42.366 19.746 62.987 7.248 11.498-7.248 111.476-75.484 74.61-225.077-0.376-2.5-2.5-20.62-3.625-30.868-2.625-31.993 28.619-103.353 79.358-158.591 35.992-39.117 72.86-60.737 103.728-60.737 7.498 0 15.621 0.125 22.995 0.375 31.243 1.374 78.483 3.374 113.6-31.743 21.62-21.62 33.618-50.365 33.493-81.108-0.109-30.744-11.997-59.612-33.727-81.358z"
                  fill="#FFFFFF"
                  p-id="5986"
                ></path>
              </svg>
              {{ $t("RatingAnalysis.SubjectCompany") }}
            </div>
            <div
              class="flex_center Deletepostion"
              v-show="!isDelTwo"
              style="color: #1a2332"
              @click="(addIndex = 3), delCompany()"
            >
              <!-- <i class="cop_del_ic"></i> -->
              <svg
                t="1730875902586"
                class="icon"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="6280"
                width="20"
                height="20"
              >
                <path
                  d="M547.4 512l278.2-278.2c9.8-9.8 9.8-25.6 0-35.4-9.8-9.8-25.6-9.8-35.4 0L512 476.6 233.8 198.4c-9.8-9.8-25.6-9.8-35.4 0-9.8 9.8-9.8 25.6 0 35.4L476.6 512 198.4 790.2c-9.8 9.8-9.8 25.6 0 35.4 4.9 4.9 11.3 7.3 17.7 7.3s12.8-2.4 17.7-7.3L512 547.4l278.2 278.2c4.9 4.9 11.3 7.3 17.7 7.3s12.8-2.4 17.7-7.3c9.8-9.8 9.8-25.6 0-35.4L547.4 512z"
                  fill="#1A2332"
                  p-id="6281"
                ></path>
              </svg>
            </div>
            <div class="cop_add">
              <div
                class="flex_center CompanyNameActive"
                v-show="isDelTwo"
                @click="(addIndex = 3), Add()"
              >
                <svg
                  t="1725586885335"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="5401"
                  width="20"
                  height="20"
                >
                  <path
                    d="M995.84 483.84H540.16V28.16a28.16 28.16 0 1 0-56.32 0v455.68H28.16a28.16 28.16 0 0 0 0 56.32h455.68v455.68a28.16 28.16 0 1 0 56.32 0V540.16h455.68a28.16 28.16 0 1 0 0-56.32z"
                    p-id="5402"
                    fill="#1290C9"
                  ></path>
                </svg>
                {{ $t("Profile.AddaCompany") }}
              </div>
            </div>
            <div
              class="line_2"
              style="font-family: 'Arial Bold'; cursor: pointer"
              @click="setidtwo(compObj3)"
            >
              {{ compObj3.CompanyName }}
            </div>
          </div>
          <div class="item">
            <div class="line_2">{{ compObj3.CompanyNativeName }}</div>
          </div>
          <div class="item">
            <div class="line_2">
              {{ compObj3.status }}
              <!-- <div class="c_d_tag">
                                <el-tag v-show="!showTranslate" v-for="(item, index) in compObj3.status" :key="index + item">{{ item }}</el-tag>
                                <el-tag v-show="showTranslate" v-for="(item, index) in compObj3.status" :key="index">{{ item}}</el-tag>
                            </div> -->
            </div>
          </div>
          <div class="item">
            <div class="line_2">{{ compObj3.LegalForm }}</div>
          </div>
          <div class="item">
            <div class="line_2">{{ compObj3.YearsinBusiness }}</div>
          </div>
          <div class="item">
            <div class="line_2">{{ compObj3.RegCapital }}</div>
          </div>
          <div class="item">
            <div class="line_2">{{ compObj3.isic }}</div>
          </div>
          <div class="item">
            <div class="line_2">{{ compObj3.IndustryDescription }}</div>
          </div>
          <div class="item">
            <div class="line_2">{{ compObj3.Listed }}</div>
          </div>
          <div class="item">
            <div class="line_2">{{ compObj3.NoofEmployees }}</div>
          </div>
          <div class="item">
            <div class="line_2">{{ compObj3.Noofshareholders }}</div>
          </div>
          <div class="item">
            <div class="line_2">{{ compObj3.Revenue }}</div>
          </div>
          <div class="item">
            <div class="line_2">{{ compObj3.Netincome }}</div>
          </div>
          <div class="item">
            <div class="line_2">{{ compObj3.TotalAssets }}</div>
          </div>
          <div class="item">
            <div class="line_2">{{ compObj3.Profitmargin }}</div>
          </div>
          <div class="item">
            <div class="line_2">{{ compObj3.Profitability }}</div>
          </div>
          <div class="item">
            <div class="line_2">{{ compObj3.BlackList }}</div>
          </div>
          <div class="item">
            <div class="line_2">{{ compObj3.CreditScore }}</div>
          </div>
          <!-- <div class="item" v-show="lastView3">
            <button class="btn_view" @click="ViewDetails(3)">
              View Details
            </button>
            <el-tooltip
              v-if="updateDisabled3"
              content="It normally takes 2-4 days to deliver,this updated rerpot."
              :visible-arrow="false"
              placement="top"
              effect="light"
            >
              <button class="btn_gray">In Production...</button>
            </el-tooltip>
            <button class="btn_view" v-else @click="getPDFFile(3)">
              Order Update Report
            </button>
          </div> -->
        </div>
      </div>
    </div>

    <el-dialog
      :visible.sync="addDialog"
      center
      :close-on-click-modal="true"
      custom-class="dialog_normal2"
      :append-to-body="true"
    >
      <div class="detail_cont">
        <h3 style="margin-bottom: 20px !important">
          {{ $t("Profile.AddaCompany") }}
        </h3>
        <div
          class="head_search flex_center"
          :class="{ search2: seachdoudong }"
          ref="input"
          style="position: relative"
        >
          <!-- 选择国家 -->
          <!-- <div class="search_left" :class="countryImg ? 'on' : ''">
            <div class="country_flag">
              <img
                :class="countryImg ? 'country_flag_img' : 'none'"
                :src="countryImg"
              />
            </div>
            <el-select
              v-model="countryCode"
              ref="select"
              clearable
              @clear="clearCountry"
              :placeholder="$t('Home.selectCountry')"
              popper-class="sel_box sel_Contry"
              @change="selectCountry"
              no-match-text="No data"
              no-data-text="No data"
            >
              <div class="search_sel_container">
                <el-tabs tab-position="left" v-model="tabActiveName">
                  <el-tab-pane
                    v-for="(tab, index) in tabCountryList"
                    :key="index"
                  >
                    <div slot="label" class="flex_center_between_box">
                      <span class="left_txt">{{ tab.continent.enName }}</span>
                      <span class="right_txt">{{
                        tab.continent.countryNumStr
                      }}</span>
                    </div>
                    <div class="right">
                      <el-option
                        v-for="item in tab.countryList"
                        :key="item.id"
                        :value="item.countryCode"
                        :label="item.nameEn"
                        @click.native="labelClick(item.label)"
                        v-show="item.companyNum > 100"
                      >
                        <div class="right_item flex_box">
                          <div class="img flex_center">
                            <img :src="item.urlBanner" />
                          </div>

                          <div class="rBox">
                            <div class="coun_title">{{ item.nameEn }}</div>
                            <div class="coun_num">{{ item.companyNumStr }}</div>
                          </div>
                        </div>
                      </el-option>
                    </div>
                  </el-tab-pane>
                </el-tabs>
              </div>
            </el-select>
           
          </div> -->
          <div
            class="country-dropdown"
            @click.stop="isCountryShow = !isCountryShow"
          >
            <span class="select-country-con">
              <template
                v-if="
                  selectCountryObj.countryCode == null ||
                  selectCountryObj.countryCode == '' ||
                  selectCountryObj.countryCode == 'undefined'
                "
              >
                <span class="country-placeholder">{{
                  $t("Home.selectCountry")
                }}</span>
              </template>
              <template v-else>
                <img
                  :src="selectCountryObj.urlBanner"
                  class="select-country-img"
                />
                <span class="select-country-name">{{
                  selectCountryObj.nameEn
                }}</span>
              </template>
              <i
                class="iconfont icon-jiantouxia"
                :class="{ 'country-arrow': isCountryShow }"
              ></i>
            </span>
          </div>

          <!-- 下拉菜单内容 -->
          <div
            ref="countryRef"
            class="country-popper"
            :class="{ 'country-show-popper': isCountryShow }"
          >
            <div class="country-popper-arrow"></div>
            <div class="country-popper-con">
              <div class="state-con">
                <div
                  class="country-state-item"
                  :class="{ activeState: selectStateIndex == index }"
                  v-for="(item, index) in stateList"
                  :key="index"
                  @click="onChangeState(index)"
                >
                  <span class="country-name">{{ item.continent.enName }}</span>
                  <span class="country-countryCount">{{
                    item.continent.countryNumStr
                  }}</span>
                </div>
              </div>
              <div class="state-country-con">
                <div
                  class="state-country-item"
                  v-for="(item, index) in stateCountryList"
                  :key="index"
                  :class="{
                    activeCountry:
                      selectCountryObj.countryCode == item.countryCode,
                  }"
                  @click="selectCountryObjFn(item)"
                >
                  <div class="state-country-item-con">
                    <img :src="item.urlBanner" />
                    <div class="state-country-info">
                      <div class="state-country-name">{{ item.nameEn }}</div>
                      <div class="state-country-companyCount">
                        {{ item.companyNumStr }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="search_btn flex_center">
            <svg
              t="1725588301247"
              class="icon"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="6045"
              width="20"
              height="20"
            >
              <path
                d="M863.38 825.09L714.17 675.88c48.01-57.12 74.18-128.58 74.18-204.08 0-84.89-33.06-164.7-93.08-224.72C635.24 187.05 555.44 154 470.55 154c-84.89 0-164.7 33.06-224.72 93.08s-93.08 139.83-93.08 224.72 33.06 164.7 93.08 224.72 139.83 93.08 224.72 93.08c76.22 0 148.33-26.67 205.72-75.56l149.08 149.08a26.805 26.805 0 0 0 19.01 7.88c6.88 0 13.76-2.63 19.01-7.88a26.805 26.805 0 0 0 7.88-19.01c0-6.89-2.62-13.77-7.87-19.02zM206.53 471.8c0-145.58 118.44-264.02 264.02-264.02 145.58 0 264.02 118.44 264.02 264.02S616.13 735.82 470.55 735.82c-145.58 0-264.02-118.44-264.02-264.02z"
                fill="#8497AB"
                p-id="6046"
              ></path>
            </svg>
            <!-- <img src="../../assets/img/head_search_ic.png" @click="searchCompanyByName()" /> -->
          </div>
          <!-- 搜索 -->
          <div class="search_right flex_center">
            <input
              type="text"
              :placeholder="$t('MyDatabase.Entercompanyname')"
              v-model="searchName"
              class="search_input"
              @keyup.enter="searchCompanyByName()"
            />
          </div>
        </div>

        <div class="" style="position: relative; margin-top: 10px">
          <div class="table_box draggable">
            <el-table
              ref="treeTable"
              :key="refresh"
              :data="parentTable"
              empty-text="No Data"
              border
              row-key="aaa_id"
              @selection-change="handleSelectionChange"
              @select-all="handleSelectAll"
              style="width: 100%"
              v-loading="parentTableloding"
            >
              <el-table-column type="selection" width="50"></el-table-column>

              <el-table-column
                :label="$t('MyDatabase.CompanyName')"
                width="360"
                align="left"
                show-overflow-tooltip
                :resizable="false"
                class-name="company company_link "
              >
                <template slot-scope="scope">
                  <div class="line_1" style="width: 340px">
                    <img :src="scope.row.flag" />
                    <div @click="setid(scope.row)" class="tbl_company line_1">
                      {{ scope.row.company_name_en }}
                    </div>
                  </div>
                </template>
              </el-table-column>

              <el-table-column
                :label="$t('Ownership.Location')"
                width="200"
                prop=""
                align="left"
                show-overflow-tooltip
                :resizable="false"
              >
                <template slot-scope="scope">
                  <div style="width: 180px" class="line_1">
                    {{ scope.row.city_en }}
                    <span
                      class="tbl_dot"
                      v-show="
                        scope.row.province_en &&
                        scope.row.province_en != ' ' &&
                        scope.row.province_en != '' &&
                        scope.row.city_en != '' &&
                        scope.row.city_en != ' ' &&
                        scope.row.city_en
                      "
                      >,</span
                    >
                    {{ scope.row.province_en }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                :label="$t('ListofResults.Industry')"
                prop="isic_en"
                align="left"
                show-overflow-tooltip
                :resizable="false"
              />
              <el-table-column
                :label="$t('MyDatabase.Status')"
                prop="status_en"
                align="left"
                show-overflow-tooltip
                :resizable="false"
              />
              <el-table-column
                :label="$t('Ownership.Type')"
                prop="company_class_en"
                align="left"
                show-overflow-tooltip
                :resizable="false"
              >
              </el-table-column>

              <el-table-column
                :label="$t('ListofResults.CompanySize')"
                prop="scale_en"
                show-overflow-tooltip
                :resizable="false"
                align="left"
              />
              <template slot="empty">
                <div style="text-align: left">No Data</div>
              </template>
            </el-table>
            <!-- <div class="page_i_box">
                            <Page :totalFont="true" :total="page.total" @onPageChange="onPageChange" @currtentPageChange="currtentPageChange"></Page>
                            <div class="search_rsult_txt line_2">{{ page.pageNo }}-{{ page.pageSize }} of over {{ page.total | FilterNum }} results for "{{ searchName }}"</div>
                        </div> -->
          </div>
        </div>
      </div>
    </el-dialog>
    <ReLogin :reLoginPop="reLoginVis"></ReLogin>
  </div>
</template>
<script>
import { searchCompany } from "@/api/searchApi.js";
import {
  getCompanyCompare,
  getCountryCollection,
  ordersAdd,
} from "@/api/companyApi.js";
import { getPdfAddress, getPdfPurchase, getPdfhk_pdf } from "@/api/userApi.js";

import { mixins1 } from "@/mixins/index";

import ReLogin from "@/components/ReLogin.vue";

export default {
  mixins: [mixins1],
  // components: { Page },
  components: {
    ReLogin,
  },
  props: {
    compareList: {
      type: Array,
      default: [],
    },
  },
  watch: {
    CompareIs: {
      handler(newVal, oldVal) {
        if (newVal) {
          this.getData();
        }
      },

      deep: true, // 深度监听，可以监听对象内部属性的变化
      immediate: true, // 立即执行一次handler函数，即使columns没有变化
    },
  },

  data() {
    return {
      reLoginVis: false,
      compObj: {
        CompanyName: "",
        aaaId: "",
        CompanyNativeName: "",
        LegalStatus: [],
        LegalForm: "",
        YearsinBusiness: "",
        RegCapital: "",
        isic: "",
        IndustryDescription: "",
        Listed: "",
        NoofEmployees: "",
        Noofshareholders: "",
        Revenue: "",
        Netincome: "",
        TotalAssets: "",
        Profitmargin: "",
        Profitability: "",
        BlackList: "",
        CreditScore: "",
      },
      compObj2: {},
      compObj3: {},
      countryVal: "",
      selCountryList: [],
      enName: "",
      addIndex: 1,
      addDialog: false,
      restaurants: [],
      lastView: false,
      lastView3: false,
      isDelOne: true,
      isDelTwo: true,
      addDisabled: true,
      companyValList: [],
      page: {
        pageNo: 1,
        pageSize: 100,
        total: 0,
      },
      pageChild: {
        pageNo: 1,
        pageSize: 100,
        total: 0,
      },
      id3a: "",
      companyCountry: "",
      companyNameEn: "",
      companyNameCn: "",
      id3a3: "",
      companyCountry3: "",
      companyNameEn3: "",
      companyNameCn3: "",
      countryObj: {},
      updateDisabled: false,
      updateDisabled3: false,
      orderStatus: "",
      offlineOrderId: "",
      offlineOrderId3: "",

      seachdoudong: false,
      //国家分类
      tabCountryList: [],
      productloding: false,
      percentageerr: false,
      countryCode1: "",
      countryCode: "",
      countryName: "", //选中国家
      countryImg: "", //选中国家的国旗
      tabActiveName: "", //选择的区域
      isNotice: true, //通知高亮
      searchName: "",
      parentTable: [],
      childTable: [],
      expands: [],
      branchflag: "",
      refresh: 0,
      parentTableloding: false,
      ret: false,
      isCountryShow: false,
      selectCountryObj: {
        countryCode: "",
      },
      stateList: [],
      stateCountryList: [],
      selectStateIndex: 0,
    };
  },
  computed: {
    //index传值 是否翻译
    showTranslate: {
      get() {
        return this.$parent.indexIsTranslate;
      },
      set() {},
    },
    CompareIs: {
      get() {
        return this.$parent.Compare;
      },
      set() {},
    },
  },
  mounted() {
    document.addEventListener("click", this.handleClickOutside);
    this.getCountryList();
  },
  beforeDestroy() {
    document.removeEventListener("click", this.handleClickOutside);
  },
  created() {},
  methods: {
    // 切换洲的选择
    onChangeState(index) {
      this.selectStateIndex = index;
      this.stateCountryList = this.stateList[index].countryList;
    },

    // 选择国家
    selectCountryObjFn(ite) {
      this.selectCountryObj = ite;
      this.countryCode = ite.countryCode;
      let newscountry = this.tabCountryList[0].countryList;
      newscountry.map((item) => {
        if (item.countryCode == ite.countryCode) {
          this.countryCode1 = item.dowjonesCountrycode;
        }
      });
      this.isCountryShow = false;
    },

    // 点击外部关闭下拉菜单
    handleClickOutside(event) {
      let countryRef = this.$refs.countryRef;
      if (countryRef && !countryRef.contains(event.target)) {
        this.isCountryShow = false;
      }
    },

    // 初始化国家数据
    async getCountryList() {
      if (localStorage.getItem("countryList")) {
        this.setCountryImg();
        this.tabCountryList = JSON.parse(localStorage.getItem("countryList"));
      } else {
        let res = await getCountryCollection();
        if (res && res.code) {
          this.$store.state.countryImgList = JSON.parse(
            localStorage.getItem("countryList"),
          );
          localStorage.setItem("countryList", JSON.stringify(res.data.rows));

          this.setCountryImg();
          this.tabCountryList = JSON.parse(localStorage.getItem("countryList"));
        }
      }
    },

    // 设置国家旗帜图片
    setCountryImg() {
      this.stateList = JSON.parse(localStorage.getItem("countryList"));
      this.stateList.map((item) => {
        item.countryList.map((itemC) => {
          if (itemC.urlBanner == null) {
            itemC.urlBanner = require("../../../../static/imagev2/zanwutupian.png");
          } else {
            let getImageUrlPath = itemC.urlBanner.split("/static")[1];
            itemC.urlBanner = require("../../../../static" + getImageUrlPath);
          }
        });
      });

      this.stateCountryList = this.stateList[0].countryList;
      // 信息参数不为空时赋值
      if (
        this.countryCode != "" &&
        this.countryCode != null &&
        this.countryCode != "undefined"
      ) {
        if (this.$route.meta.title == "NewsList") {
          this.selectCountryObj = this.stateCountryList.filter(
            (item) => item.countryCode == this.countryCode,
          )[0];
        } else {
          let filterData = this.sanctionList.filter(
            (item) => item.dictDataCode == this.countryCode,
          )[0];
          this.selectSanctionObj = {
            sanctionCode: filterData.dictDataCode,
            sanctionName: filterData.dictDataName,
          };
        }
      }
    },
    setidtwo(row) {
      let newscountry = JSON.parse(localStorage.getItem("countryList"))[0]
        .countryList;
      let companyCountryEn = "";
      let company_country = this.countryCode;
      newscountry.map((item) => {
        if (item.countryCode == this.countryCode) {
          companyCountryEn = item.dowjonesCountrycode;
        }
      });
      let routeData = this.$router.resolve({
        path:
          "/index/company/details/" +
          row.aaaId +
          "/background/snapshot?id3a=" +
          row.aaaId +
          "&companyCountry=" +
          company_country +
          "&companyCountryEn=" +
          companyCountryEn +
          "&keword=" +
          this.$route.query.keword,
      });

      window.open(routeData.href, "_blank");
    },
    CompareShow() {
      this.compObj = {};
      this.compObj2 = {};
      this.compObj3 = {};
      (this.lastView = false),
        (this.lastView3 = false),
        (this.isDelOne = true),
        (this.isDelTwo = true),
        this.$emit("CompareShowfalse", false);
      if (this.$store.state.app.searchType == "company") {
        this.$router.go(0);
      }
    },
    handleSelectAll(selection) {
      if (selection.length > 1) {
        this.$refs.treeTable.clearSelection();
        this.$refs.treeTable.toggleRowSelection(selection[0]);
      }
    },
    // 全选
    handleSelectionChange(selection) {
      if (selection.length > 0) {
        this.handleSelect(selection[0]);
      }
    },
    // 国旗跳转
    // gotocountry(row) {
    //   let routeData = this.$router.resolve({
    //     path: "/country?" + "&companyCountry=" + row.company_country,
    //   });

    //   window.open(routeData.href, "_blank");
    // },
    // 点击跳转
    // 点击跳转
    setid(row) {
      sessionStorage.setItem("company", JSON.stringify(row));
      let newscountry = JSON.parse(localStorage.getItem("countryList"))[0]
        .countryList;
      let companyCountryEn = "";
      newscountry.map((item) => {
        if (item.countryCode == row.company_country) {
          companyCountryEn = item.dowjonesCountrycode;
        }
      });
      let routeData = this.$router.resolve({
        path:
          "/index/company/details/" +
          row.aaa_id +
          "/background/snapshot?id3a=" +
          row.aaa_id +
          "&companyCountry=" +
          row.company_country +
          "&companyCountryEn=" +
          companyCountryEn +
          "&keword=" +
          this.$route.query.keword,
      });

      window.open(routeData.href, "_blank");
    },
    //分页

    //清除选择的国家
    clearCountry() {
      this.countryImg = "";
      this.countryCode = "";
      this.countryCode1 = "";
    },

    //下拉选择国家
    selectCountry(val) {
      let countryImg = this.getCountryImgUrl(val);
      let flag = require("../../../../static" + countryImg);
      this.countryImg = flag;
      this.countryCode = val;

      let newscountry = this.tabCountryList[0].countryList;
      newscountry.map((item) => {
        if (item.countryCode == val) {
          this.countryCode1 = item.dowjonesCountrycode;
        }
      });
    },
    // 选中国家
    labelClick(label) {},
    async getData() {
      let compareList = this.compareList.slice(0, 3);
      compareList.map((item, index) => {
        getCompanyCompare("id3a=" + item.aaa_id)
          .then((resdata) => {
            if (resdata.code == 200) {
              if (index == 0) {
                let res = resdata.data;
                this.compObj = {
                  aaaId: res.aaaId,
                  CompanyName: res.nameEn,
                  CompanyNativeName: res.name,
                  LegalStatus: res.lables,
                  // Company Legal Status
                  LegalForm: res.legalForm,
                  YearsinBusiness: res.yearsInBusiness,
                  RegCapital: res.regCapital,
                  isic: res.isic,
                  IndustryDescription: res.industryDescription,
                  Listed: res.listed,
                  NoofEmployees: res.noOfEmployees,
                  Noofshareholders: res.noOfShareholders,
                  Revenue: res.revenue,
                  Netincome: res.netIncome,
                  TotalAssets: res.totalAssets,
                  status: res.status,
                  Profitmargin: res.profitMargin,
                  Profitability: res.profitability,
                  BlackList: res.blackList,
                  CreditScore: res.creditScore,
                };
              }
              if (index == 1) {
                let res1 = resdata.data;
                this.compObj2 = {
                  aaaId: res1.aaaId,
                  CompanyName: res1.nameEn,
                  CompanyNativeName: res1.name,
                  LegalStatus: res1.lables,
                  // Company Legal Status
                  LegalForm: res1.legalForm,
                  YearsinBusiness: res1.yearsInBusiness,
                  RegCapital: res1.regCapital,
                  isic: res1.isic,
                  IndustryDescription: res1.industryDescription,
                  Listed: res1.listed,
                  NoofEmployees: res1.noOfEmployees,
                  Noofshareholders: res1.noOfShareholders,
                  Revenue: res1.revenue,
                  Netincome: res1.netIncome,
                  TotalAssets: res1.totalAssets,
                  status: res1.status,
                  Profitmargin: res1.profitMargin,
                  Profitability: res1.profitability,
                  BlackList: res1.blackList,
                  CreditScore: res1.creditScore,
                };
                this.isDelOne = false;
                this.lastView = true;
              }
              if (index == 2) {
                let res2 = resdata.data;
                this.compObj3 = {
                  aaaId: res2.aaaId,
                  CompanyName: res2.nameEn,
                  CompanyNativeName: res2.name,
                  LegalStatus: res2.lables,
                  // Company Legal Status
                  LegalForm: res2.legalForm,
                  YearsinBusiness: res2.yearsInBusiness,
                  RegCapital: res2.regCapital,
                  isic: res2.isic,
                  IndustryDescription: res2.industryDescription,
                  Listed: res2.listed,
                  NoofEmployees: res2.noOfEmployees,
                  Noofshareholders: res2.noOfShareholders,
                  Revenue: res2.revenue,
                  Netincome: res2.netIncome,
                  TotalAssets: res2.totalAssets,
                  status: res2.status,
                  Profitmargin: res2.profitMargin,
                  Profitability: res2.profitability,
                  BlackList: res2.blackList,
                  CreditScore: res2.creditScore,
                };
                this.isDelTwo = false;
                this.lastView3 = true;
              }
            }
          })
          .catch((err) => {
            this.reLoginVis = String(err).includes("403");
          });
      });
    },
    //搜索公司
    async searchCompanyByName() {
      this.parentTableloding = true;
      let params = {
        company_name: this.searchName,
        company_country: this.countryCode,
        page: this.page.pageNo,
        pageSize: this.page.pageSize,
      };
      let res = await searchCompany(params);
      this.parentTable = [];

      if (res && res.code) {
        this.page.total = res.data.total;
        let list = (this.parentTable = res.data.rows);
        //查找本地图片
        list = list.map((item, index) => {
          let countryImg = this.getCountryImgUrl(item.company_country);
          let flag = require("../../../../static" + countryImg);
          this.parentTable[index].flag = flag;
          this.refresh++;
        });
        this.parentTableloding = false;
      } else {
        this.loading = false;
        // this.addPopIndex2=true
        this.parentTable = [];
        this.parentTableloding = false;
        if (res.ret == "1002") {
          this.ret = true;
        } else {
          this.ret = false;
        }
      }
      // }
    },
    //获取国家
    async getAllCountry() {
      let countryCode = (this.countryCode = this.$route.query.companyCountry
        ? this.$route.query.companyCountry
        : "");
      // localStorage.setItem('countryList',JSON.stringify(countryImgList))
      // 处理缓存问题
      if (JSON.parse(localStorage.getItem("countryList"))) {
        this.tabCountryList = JSON.parse(localStorage.getItem("countryList"));
        let list = this.tabCountryList;
        list.forEach((item, index) => {
          item.countryList.forEach((it) => {
            let countryImg = "";
            if (it.urlBanner == null) {
              countryImg = "../../../../static/imagev2/zanwutupian.png";
            } else {
              countryImg = it.urlBanner.split("./../../../static")[1];
            }
            // let flag = require('../../static' + countryImg);
            let flag = "";
            try {
              flag = require("../../../../static" + countryImg);
            } catch (error) {
              countryImg = "../../../../static/imagev2/zanwutupian.png";
              // 提供一个默认值或者其他处理方式
              flag = require("../../../../static" + countryImg);
            }
            it.urlBanner = flag;
            if (countryCode && it.countryCode == countryCode) {
              this.countryName = it.nameEn;
              this.countryImg = it.urlBanner;
            }
          });
        });
      } else {
        // 清理缓存后重新请求页面
        let res = await getCountryCollection();
        if (res && res.code) {
          let countryImgList = res.data.rows;
          this.$store.state.countryImgList = JSON.parse(
            localStorage.getItem("countryList"),
          ); //res.data.rows
          this.tabCountryList =
            JSON.parse(localStorage.getItem("countryList")) == null
              ? res.data.rows
              : JSON.parse(localStorage.getItem("countryList"));

          localStorage.setItem("countryList", JSON.stringify(countryImgList));
          let list = this.tabCountryList;

          list.forEach((item, index) => {
            item.countryList.forEach((it) => {
              let countryImg = "";
              if (it.urlBanner == null) {
                countryImg = "../../../../static/imagev2/zanwutupian.png";
              } else {
                countryImg = it.urlBanner.split("./../../../static")[1];
              }
              // let flag = require('../../static' + countryImg);
              let flag = "";
              try {
                flag = require("../../../../static" + countryImg);
              } catch (error) {
                countryImg = "../../../../static/imagev2/zanwutupian.png";
                // 提供一个默认值或者其他处理方式
                flag = require("../../../../static" + countryImg);
              }
              it.urlBanner = flag;
              if (countryCode && it.countryCode == countryCode) {
                this.countryName = it.nameEn;
                this.countryImg = it.urlBanner;
              }
            });
          });
        }
      }
    },

    //add compant弹框
    Add() {
      this.parentTable = [];
      this.getAllCountry();
      this.countryImg = "";
      this.countryVal = "";
      this.searchName = "";
      this.addDialog = true;
    },
    // 确定提交
    async submitAdd() {
      let id3a = this.addIndex == 2 ? this.id3a : this.id3a3;
      let companyCountry =
        this.addIndex == 2 ? this.companyCountry : this.companyCountry3;
      let params = "aaaId=" + id3a;
      let that = this;
      this.geitadddate(id3a, companyCountry);
      // getPdfPurchase(params).then(res => {
      //     // if (res.code) {
      //     let repordshow = res.data?.onlineReport?.type;
      //     if (repordshow != 1) {
      //         let type = that.addIndex;
      //         this.getOrdersAdd(type, 1).then(res => {
      //             if (res) {
      //                 this.geitadddate(id3a, companyCountry);
      //             }
      //         });
      //     } else {
      //         this.geitadddate(id3a, companyCountry);
      //     }
      //     // }
      // });
    },
    async geitadddate(id3a, companyCountry) {
      let CompanyName =
        this.addIndex == 2 ? this.companyNameEn : this.companyNameEn3;
      let CompanyNativeName =
        this.addIndex == 2 ? this.companyNameCn : this.companyNameCn3;
      let result = await getCompanyCompare(
        "id3a=" + id3a + "&companyCountry=" + companyCountry,
      );
      //解密
      let data = result;
      // let data = JSON.parse(crypto.decrypt(result));
      if (data.code == 200) {
        let res = data.data;
        let obj = {
          aaaId: res.aaaId,
          CompanyName: CompanyName,
          CompanyNativeName: CompanyNativeName,
          LegalStatus: res.lables,
          LegalForm: res.legalForm,
          YearsinBusiness: res.yearsInBusiness,
          RegCapital: res.regCapital,
          isic: res.isic,
          IndustryDescription: res.industryDescription,
          Listed: res.listed,
          NoofEmployees: res.noOfEmployees,
          Noofshareholders: res.noOfShareholders,
          Revenue: res.revenue,
          Netincome: res.netIncome,
          TotalAssets: res.totalAssets,
          Profitmargin: res.profitMargin,
          Profitability: res.profitability,
          BlackList: res.blackList,
          status: res.status,
          CreditScore: res.creditScore,
        };
        if (this.addIndex == 2) {
          this.compObj2 = obj;
          this.isDelOne = false;
          this.lastView = true;
          //查看PDF状态
          //   this.hasPdfPurchase(2);
        } else {
          this.compObj3 = obj;
          this.isDelTwo = false;
          this.lastView3 = true;

          //查看PDF状态
          //   this.hasPdfPurchase(3);
        }
        this.addDialog = false;
      }
    },

    handleSelect(item) {
      this.searchName = item.company_name_en;
      this.addDisabled = false;

      this.countryObj = item;
      if (this.addIndex == 2) {
        this.id3a = item.aaa_id;
        this.companyCountry = item.company_country;
        this.companyNameCn = item.company_name;
        this.companyNameEn = item.company_name_en;
      } else {
        this.id3a3 = item.aaa_id;
        this.companyCountry3 = item.company_country;
        this.companyNameCn3 = item.company_name;
        this.companyNameEn3 = item.company_name_en;
      }
      this.submitAdd();
    },
    //删除添加
    delCompany() {
      if (this.addIndex == 2) {
        this.compObj2 = {};
        this.isDelOne = true;
        this.lastView = false;
        this.parentTable = [];
      } else {
        this.compObj3 = {};
        this.isDelTwo = true;
        this.lastView3 = false;
        this.parentTable = [];
      }
    },

    //  跳转公司详情
    ViewDetails(val) {
      let id3a = val == 2 ? this.id3a : this.id3a3;
      let companyCountry =
        val == 2 ? this.companyCountry : this.companyCountry3;
      this.$emit("updateSubLink", 0);
      sessionStorage.setItem("company", JSON.stringify(this.countryObj));
      // this.$router.push({
      //     path: '/company/companysnapshot?id3a=' + id3a + '&companyCountry=' + companyCountry,
      // });

      let routeData = this.$router.resolve({
        path:
          "/company/companysnapshot?id3a=" +
          id3a +
          "&companyCountry=" +
          companyCountry +
          "&keword=" +
          this.$route.query.keword,
      });

      window.open(routeData.href, "_blank");
    },

    //step-1  获取 判断是否要扣点 线上报告,线下报告
    getPDFFile(val) {
      //有订单号吗
      if (!this.offlineOrderId) {
        let type = 2;
        this.getOrdersAdd(val, type).then((res) => {
          if (res) this.hanldPdfPurchase();
        });
      } else {
        this.hanldPdfPurchase();
      }
    },
    //step-3   1.查找订单；2.下载PDF
    async hanldPdfPurchase() {
      if (this.offlineOrderId) {
        await getPdfAddress(this.offlineOrderId).then((res) => {
          if (res && res.code) {
            window.open(res.data, "_blank");
          } else {
            this.$message({
              message:
                "It normally takes 2-4 days to deliver,this updated rerpot.",
              duration: 5000,
            });
          }
        });
      }
    },
    //step-2 是否购买PDF,获取订单号
    async hasPdfPurchase(val) {
      let id3a = val == 2 ? this.id3a : this.id3a3;
      let params = "aaaId=" + id3a;
      await getPdfPurchase(params).then(async (res) => {
        if (res && res.code) {
          if (res.data.offlineReport) {
            this.offlineOrderId = res.data.offlineReport.id;
            this.orderStatus = res.data.offlineReport.orderStatus;
            if (this.orderStatus == "4") {
              if (val == 2) {
                this.updateDisabled = true;
              } else {
                this.updateDisabled3 = true;
              }
            } else {
              if (val == 2) {
                this.updateDisabled = false;
              } else {
                this.updateDisabled3 = false;
              }
            }
          }
        } else {
          if (val == 2) {
            this.updateDisabled = false;
          } else {
            this.updateDisabled3 = false;
          }
        }
      });
    },
    /**
     *用户购买报告 "type": 1 线下，2 线上, 13 Import/Export
     */
    async getOrdersAdd(val, type) {
      let id3a = val == 2 ? this.id3a : this.id3a3;
      let companyCountry =
        val == 2 ? this.companyCountry : this.companyCountry3;
      let companyName = val == 2 ? this.companyNameEn : this.companyNameEn3;
      //1  :线上报告
      let params = {
        companyName: companyName, //必须
        aaaId: id3a, //必须
        companyCountry: companyCountry, //必须
        method: "0", //支付方式  0：帐号余额 1：支付宝 2：微信 ，3 国际万事达卡 支付 传  0   //必须
        methodType: "0", //支付类型： 1 免费额度 ，0 充值额度       //(非必须)
        type: type, //订单类型 //必须
      };
      let status = "";

      await ordersAdd(params).then((result) => {
        let data = result;
        if (data && data.code) {
          this.hasPdfPurchase(val);
          status = true;
          this.$message({
            message: data.msg,
            type: "success",
            // duration: 5000,
          });
        } else {
          this.$message({
            message: data.msg,
            type: "error",
            // duration: 5000,
          });
          let that = this;
          let userinfo = JSON.parse(localStorage.getItem("userInfo")).userInfo;

          let routeData = "";
          setTimeout(function () {
            if (userinfo.type == "3") {
              routeData = that.$router.resolve({
                path: "/account/quota",
              });
            } else {
              routeData = that.$router.resolve({
                path: "/account/addCredit",
              });
            }

            window.open(routeData.href, "_blank");
          }, 2000);

          status = false;
        }
      });
      return status;
    },
  },
};
</script>
<style scoped lang="less">
.sel_coun {
  position: relative;
}

.country_img {
  position: absolute;
  top: 4px;
  left: 4px;
  z-index: 8;
}

.country_img img {
  width: 40px;
  height: 28px;
}

.el-select,
.el-autocomplete {
  width: 100%;
}

.create_item /deep/ .el-input__inner {
  width: 100%;
  height: 35px;
  border-radius: 7px;
  border: 1px solid #8497ab;
}

.country_sel /deep/ .el-input__inner {
  padding-left: 48px;
}

.create_item /deep/ .el-autocomplete .el-input__inner {
  // background-image: url(../../assets/img/head_search_ic.png);
  background-size: 18px;
  background-repeat: no-repeat;
  background-position: 98%;
  padding-right: 52px;
}

.create_item {
  margin-bottom: 18px;
}

.cop_title {
  display: flex;
  align-items: center;
  margin-top: 5px;
  margin-bottom: 30px;
  margin-left: 20px;
  font-family: "Arial Bold";
  font-weight: normal;
  font-size: 20px;
  color: #1a2332;
  line-height: 27px;
  text-align: left;
  font-style: normal;
}

.cop_title .icon {
  width: 26px;
  height: 24px;
  margin-right: 20px;
  cursor: pointer;
}

.cop_cont_head {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 35px;
  background: #f2f5f9;
  // border-radius: 1rem 1rem 0rem 0rem;
  // border: 0.07142857142857142rem solid #e7eaed;
  // background: #f2f5f9;
  color: #8497ab;
  font-size: 16px;
}

.cop_company {
  width: 26%;
  // width: 41.285714285714285rem;
  line-height: 34px;
  color: #1a2332;
  font-family: "Arial Bold";
  // padding-left: 28.571428571428573rem;
}

.cop_companyfirst {
  width: 23.5%;
}

.cop_add {
  // width: 18.857142857142858rem;
  // width: 25%;
  height: 35px;
  cursor: pointer;
}

.cop_add .flex_center {
  height: 35px;
}

.cop_add_ic {
  background: #1290c9;
  // background-image: url(../../assets/img/detail/add_ic.png);
}

.cop_del_ic {
  background: #f56b6b;
  // background-image: url(../../assets/img/detail/del_ic.png);
}

.cop_del_ic,
.cop_add_ic {
  width: 20px;
  height: 20px;
  background-repeat: no-repeat;
  background-size: 8px;
  background-position: center;
  border-radius: 50%;
  margin-right: 8px;
}

.cop_cont_box {
  position: relative;
  background: #ffffff;
  // padding-top: 2.857142857142857rem;
}

.cop_cont_cont .item {
  display: flex;
  align-items: center;
  height: 60px;
  padding: 0 20px;
  border-bottom: 1px solid #cccccc;
  font-family: "Arial";
  font-size: 18px;
  color: #1a2332;
  line-height: 21px;
  text-align: left;
  font-style: normal;
}

.cop_cont_cont .list.title .item:not(:first-child) {
  // width: 20rem;
  overflow: hidden;
  padding: 20px 18px;
  color: #999999;
}

.cop_cont_cont .list.content {
  // width: 21.428571428571427rem;
  width: 27%;
  // border-left: 0.07142857142857142rem solid #e7eaed;
}

.cop_cont_cont .list.content.last {
  width: 234px;
}

.line_2 .c_d_tag {
  width: 216px;
}

.c_d_tag .el-tag {
  height: 22px;
  line-height: 22px;
  background: #ffffff;
  border-radius: 7px;
  border: 1px solid #ff7600;
  font-size: 12px;
  color: #ff7600;
  margin: 0 4px 2px;
}

.btn_box {
  margin-top: 26px;
}

.btn_return {
  width: 124px;
  height: 35px;
  line-height: 35px;
  background: #e7eaed;
  border-radius: 10px;
  font-size: 14px;
  color: #1a2332;
}

.create_item_lab {
  font-size: 14px;
  color: #1a2332;
  margin-bottom: 7px;
}

.create_inpt {
  width: 100%;
  height: 40px;
  background: #ffffff;
  border-radius: 10px;
  border: 1px solid #e7eaed;
  font-size: 14px;
  padding: 12px 18px;
  margin-bottom: 18px;
}

.btn_view {
  padding: 7px 5px;
  background: #edf9ff;
  border-radius: 10px;
  border: 1px solid #1290c9;
  color: #1290c9;
  height: 30px;
  line-height: 16px;
  font-size: 12px;
}

.btn_view + .btn_view {
  margin-left: 7px;
}

.name_ser {
  position: relative;
}

.ser_icon {
  position: absolute;
  right: 0;
  top: 0;
  width: 52px;
  height: 35px;
}

.btn_gray,
.btn_blue {
  width: 124px;
  height: 30px;
  line-height: 30px;
  background: #1290c9;
  border-radius: 10px;
  font-size: 12px;
  color: #ffffff;
  cursor: pointer;
  text-align: center;
}

.btn_gray,
.btn_blue:disabled {
  color: #8497ab;
  background: #e7eaed;
}

.btn_gray {
  margin-left: 9px;
}

.btn_blue img {
  width: 16px;
  height: 16px;
  margin-right: 5px;
}

// .right_box/deep/ .el-dialog__wrapper {
//     overflow: visible;
//     z-index: 2004 !important;
//     position: fixed;
//     top: 9.357142857142858rem;
//     right: 0;
//     bottom: 0;
//     left: 0;
// }

.el-radio__inner {
  width: 18px;
  height: 18px;
}

/* 搜索 */
.head_search {
  // width: 67.85714285714286rem;
  height: 54px;
  // border-radius: 1rem;
  color: #022955;
  // margin: auto;
  // margin-left: 4.428571428571429rem;

  background: #ffffff;
  border-radius: 10px;
  border: 1px solid #cccccc;
}

.search_right {
  flex: 1;
  position: relative;
}

.search_input {
  width: 100%;
  word-wrap: break-word;
  line-height: 18px;
  outline: none;
  border: none;
  // padding: 0 1.4285714285714286rem;
  font-size: 16px;
}

.search_btn {
  width: 20px;
  height: 20px;
  margin-left: 10px;
  margin-right: 10px;
  cursor: pointer;
}

.search_btn img {
  width: 21px;
}

/* 选择下拉 */
.search_left {
  width: 210px;
  height: 100%;
  position: relative;
  display: flex;
  align-items: center;
}

.search_left::after {
  content: "";
  position: absolute;
  right: 0;
  top: 10px;
  width: 1px;
  height: 30px;
  background-color: #e7eaed;
}

.search_left /deep/ .el-input__inner {
  border: none;
  font-size: 14px;
}

/deep/ .el-input__inner {
  padding-right: 0rem !important;
}

.country_flag {
  display: flex;
  align-items: center;
}

.country_flag_img {
  width: 44px;
  height: 30px;
  margin: 12px 0 12px 5px;
}

.sel_value {
  width: 56px;
  font-size: 12px;
  word-break: break-all;
}

.search_left .el-select {
  position: absolute;
  top: 0;
  width: 214px;
}

.search_left /deep/ .el-select .el-input__inner {
  background-color: transparent;
  height: 52px;
  /* opacity: 0; */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-family: "Arial";
  font-size: 14px;
  color: #1a2332;
  line-height: 18px;
  text-align: left;
  font-style: normal;
}

.search_left.on /deep/ .el-select .el-input__inner {
  padding-left: 52px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.head_pro_cas /deep/ .el-input__inner::placeholder,
.search_left /deep/ .el-select .el-input__inner::placeholder {
  color: #666666;
  /* 红色 */
}

.head_pro_cas /deep/ .el-icon-arrow-down:before,
.search_left /deep/ .el-select .el-icon-arrow-up:before {
  color: #8497ab !important;
  // font-weight: 600;
}

.sel_place {
  width: 100%;
  line-height: 46px;
  padding-left: 18px;
  display: inline-block;
  font-size: 12px;
}

.el-select-dropdown__wrap {
  max-height: 330px !important;
}

/* .el-cascader__dropdown{
z-index: 9999999 !important;
} */
.el-select-dropdown__list {
  padding: 9px 0 !important;
}

.search_sel_container {
  width: 1054px;
}

.search_sel_container /deep/ .el-tabs--left .el-tabs__nav-wrap.is-left {
  // width: 17.142857142857142rem;
}

.search_sel_container /deep/ .el-tabs--left .el-tabs__nav-wrap.is-left::after {
  width: 1px;
  background-color: #eee;
}

.head_swi_keyword {
  position: relative;
}

.head_swi_keyword .el-switch,
.head_login .el-switch {
  height: 30px;
  line-height: 30px;
}

.head_swi_keyword /deep/ .el-switch__core,
.head_login /deep/ .el-switch__core {
  width: 86px !important;
  height: 30px;
  background: #006a9a;
  box-shadow: inset 0 1px 2px 0 #054562;
  border-radius: 15px;
  border: none;
}

.head_swi_keyword /deep/ .el-switch__core {
  width: 88px !important;
}

.head_swi_keyword /deep/ .el-switch.is-checked .el-switch__core {
  background: #ff7600;
  box-shadow: inset 0 1px 2px 0 #aa4f00;
}

.head_swi_keyword /deep/ .el-switch__core:after,
.head_login /deep/ .el-switch__core:after {
  top: 3px;
  left: 3px;
  width: 24px;
  height: 24px;
  background: #ffffff;
}

.head_swi_keyword /deep/ .el-switch.is-checked .el-switch__core::after {
  left: 76px;
}

.search_sel_container /deep/ .el-tabs__active-bar {
  display: none;
}

.search_sel_container .right {
  width: 842px;
  display: flex;
  flex-wrap: wrap;
  flex: 1;
  max-height: 298px;
  align-content: flex-start;
  margin-right: 1px;
  padding: 0 7px;
  overflow: auto;
}

.search_sel_container /deep/ .el-tabs--left .el-tabs__item.is-left {
  height: 38px;
  // line-height: 3rem;
  margin-bottom: 7px;
  padding: 0 9px !important;
  display: flex;
  align-items: center;
}

.search_sel_container /deep/ .el-tabs__item.is-left.is-active {
  background: #f5f5f5;
}

.el-select-dropdown__item:hover {
  background: #f5f5f5;
}

.search_sel_container /deep/ .el-tabs__item:hover {
  color: #1290c9;
  font-weight: normal;
}

.search_sel_container .left_txt {
  font-size: 14px;
  margin-right: 10px;
}

.search_sel_container .right .el-select-dropdown__item {
  width: 196px;
  height: 50px;
  padding: 0 9px;
  margin: 4px;
  border: 1px solid #fff;
  background: #f5f5f5;
}

.search_sel_container .right /deep/ .el-select-dropdown__item.selected,
.search_sel_container .right /deep/ .el-select-dropdown__item.hover {
  background: #f5f5f5;
  /* border-radius: 1rem; */
  border: 1px solid #1290c9;
}

.search_sel_container .right /deep/ .el-select-dropdown__item.selected {
  color: #022955;
  font-weight: normal;
}

.right_item {
  height: 100%;
  width: 100%;
}

.search_sel_container .right .img {
  width: 48px;
  height: 100%;
  margin-right: 4px;
}

.search_sel_container .right .rBox {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.search_sel_container .right .rBox .coun_title {
  font-size: 14px;
  line-height: 1;
  margin-bottom: 4px;
  max-width: 124px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.table_box /deep/ .el-table__empty-block .el-table__empty-text {
  width: auto;
  /* justify-content: flex-start !important; */
}

.table_box /deep/ .el-table {
  height: 736px;
  border: 1px solid #cccccc;
  border-radius: 4px;
}

::v-deep .el-table__body-wrapper {
  height: 90% !important;
  overflow-y: auto !important;
}

.table_box /deep/ .el-table th > .cell,
.table_box /deep/ td.el-table__cell > .cell {
  padding-right: 10px;
  font-family: "Arial";
  word-break: keep-all;
  font-weight: normal;
  font-size: 18px;
  color: #1a2332;
  line-height: 22px;
  text-align: left;
  font-style: normal;
  padding: 0 10px;
}

.table_box /deep/ .el-table th > .cell {
  font-family: "Arial Bold";
}

.table_box /deep/ .el-table--border .el-table__cell:first-child .cell {
  padding-left: 20px !important;
}

.table_box /deep/ th.el-table__cell {
  height: 50px;
  padding: 0 !important;
  box-sizing: border-box;
}

.table_box /deep/ .el-table thead {
  height: 50px !important;
}

.table_box /deep/ td.el-table__cell {
  height: 60px;
  padding: 0 !important;
  box-sizing: border-box;
}

.table_box .el-table__row .company img {
  float: left;
  width: 40px;
  height: 28px;
  flex: none;
  margin-right: 5px;
}

.tbl_company {
  line-height: 32px;
}

.list-title {
  width: 25%;
}

.CompanyNameActive {
  font-family: "Arial";
  font-weight: normal;
  font-size: 22px;
  color: #1290c9;
  line-height: 30px;
  text-align: left;
  font-style: normal;
}

.CompanyNameActive .icon {
  width: 20px;
  height: 20px;
  margin-right: 10px;
}

.el-select /deep/ .el-input__suffix {
  right: 12px !important;
}

.content {
  padding: 0;
  margin: 0 !important;
}

.flex_center {
  justify-content: flex-start;
}

.item_active {
  height: 140px !important;
  position: relative;
  background: #f2f5f9;
  box-shadow: 0 2px 4px 0 rgba(30, 33, 45, 0.12);
}

.list:not(:first-child) .item_active {
  font-size: 22px;
  line-height: 26px;
}

.list:first-child .item_active {
  border-radius: 4px 0 0 0;
}

.list:last-child .item_active {
  border-radius: 0 4px 0 0;
}

.Deletepostion {
  position: absolute;
  top: 10px;
  right: 10px;
}

.Deletepostion .icon {
  width: 20px;
  height: 20px;
}

.Deletepostionleft {
  position: absolute;
  top: 0;
  left: 0;
  width: 200px;
  height: 40px;
  background: #a6b7c9;
  border-radius: 0px 0px 20px 0px;
  display: flex;
  align-items: center;
  font-family: "Arial";
  font-size: 18px;
  color: #ffffff;
  line-height: 22px;
  text-align: left;
  font-style: normal;
}

.Deletepostionleft .icon {
  width: 20px;
  height: 20px;
  margin: 0 8px 0 10px;
}

::v-deep .el-dialog__headerbtn .el-dialog__close {
  font-size: 20px !important;
}
::v-deep .dialog_normal2,
::v-deep .dialog_normalmengent {
  width: 1500px !important;
}

.country-dropdown,
.trade-dropdown {
  position: relative;
  width: 210px;
  min-width: 210px;
  border-radius: 27px 0 0 27px;
  margin-right: 10px;
}

.country-dropdown::after,
.trade-dropdown::after {
  content: "";
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 1px;
  height: 30px;
  background: #dddddd;
}

.select-country-con {
  display: flex;
  align-items: center;
  width: 100%;
  height: 40px;
  padding: 0 14px 0 20px;
  cursor: pointer;
}

.select-country-con .country-placeholder {
  flex: 1;
  font-size: 16px;
  color: #1a2332;
}

.select-country-con i {
  font-size: 16px;
  color: #1a2332;
  transition: all 0.3s;
}

.select-country-img {
  width: 34px;
  height: 20px;
  margin-right: 6px;
  box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.2);
}

.select-country-name {
  flex: 1;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  margin-right: 6px;
  line-height: 20px;
  font-size: 18px;
  color: #1a2332;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.u942df .iconfont {
  font-size: 22px;
}

.country-arrow {
  transform: rotate(180deg);
}

.country-popper {
  position: absolute;
  top: 68px;
  left: 0;
  width: 1000px;
  height: 300px;
  padding: 18px 5px 0px 0;
  margin-top: 0 !important;
  background: #ffffff;
  box-shadow: 0px -8px 20px 0px rgba(10, 33, 57, 0.24);
  border-radius: 12px;
  z-index: -1;
  opacity: 0;
  pointer-events: none;
  transition: all 0.3s ease-in-out;
}

.country-show-popper {
  width: 1178px;
  height: 378px;
  opacity: 1;
  z-index: 2001;
  pointer-events: all;
  transition: all 0.3s ease-in-out;
}

.country-popper-arrow,
.country-popper-arrow::after {
  position: absolute;
  display: block;
  width: 0;
  height: 0;
  border-color: transparent;
  border-style: solid;
}

.country-popper-arrow {
  left: 90px;
  top: -12px;
  border-width: 12px;
  border-top-width: 0;
  border-bottom-color: #ffffff;
}

.country-popper-arrow::after {
  content: "";
  border-width: 12px;
  border-bottom-color: #ffffff !important;
  filter: drop-shadow(0px -8px 20px 0px rgba(10, 33, 57, 0.24)) !important;
}

.country-popper-con {
  display: flex;
  height: 100%;
  overflow: hidden;
}

.country-popper-con .state-con {
  width: 220px;
  height: calc(100% - 18px);
  flex-shrink: 0;
  border-right: 1px solid #dddddd;
  overflow: auto;
}

.country-popper-con .country-state-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 42px;
  padding: 0 20px;
  cursor: pointer;
}

.country-popper-con .country-state-item:not(:last-child) {
  margin-bottom: 8px;
}

.country-popper-con .country-state-item.activeState {
  background: #f5f5f5;
}

.country-popper-con .country-state-item:hover .country-name,
.country-popper-con .country-state-item.activeState .country-name {
  color: #1290c9;
}

.country-popper-con .country-name {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;

  font-size: 16px;
  color: #1a2332;
}

.country-popper-con .country-countryCount {
  width: 30px;
  font-size: 14px;
  color: #999999;
  text-align: right;
}

.country-popper-con .state-country-con {
  width: 953px;
  display: flex;
  flex-wrap: wrap;
  flex-shrink: 0;
  align-content: flex-start;
  padding-left: 20px;
  overflow: auto;
}

.country-popper-con .state-country-item {
  width: 222px;
  height: 56px;
  padding: 8px 10px;
  margin-bottom: 10px;
  background: #f5f5f5;
  border: 1px solid #f5f5f5;
  cursor: pointer;
}

.country-popper-con .state-country-item-con {
  display: flex;
  align-items: center;
  justify-content: start;
}

.country-popper-con .state-country-item:hover,
.country-popper-con .state-country-item.activeCountry {
  border-color: #1290c9;
}

.country-popper-con .state-country-item:not(:nth-child(4n)) {
  margin-right: 10px;
}

.country-popper-con .state-country-item img {
  width: 56px;
  height: 34px;
  margin-right: 6px;
  box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.2);
}

.country-popper-con .state-country-info {
  flex: 1;
  overflow: hidden;
}

.country-popper-con .state-country-name {
  line-height: 20px;
  margin-bottom: 4px;
  font-size: 16px;
  color: #1a2332;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.country-popper-con .state-country-companyCount {
  font-size: 14px;
  color: #999999;
  line-height: 1;
}

@media screen and (max-width: 1920px) {
  .country_img img {
    width: 30px;
    height: 22px;
  }

  .create_item /deep/ .el-input__inner {
    height: 26px;
    border-radius: 5px;
  }

  .country_sel /deep/ .el-input__inner {
    padding-left: 36px;
  }

  .create_item /deep/ .el-autocomplete .el-input__inner {
    background-size: 14px;
    padding-right: 40px;
  }

  .create_item {
    margin-bottom: 14px;
  }

  .cop_title {
    margin-top: 4px;
    margin-bottom: 22px;
    margin-left: 15px;
    font-size: 20px;
    line-height: 22px;
  }

  .cop_title .icon {
    width: 20px;
    height: 18px;
    margin-right: 15px;
  }

  .cop_cont_head {
    height: 26px;
    font-size: 14px;
  }

  .cop_company {
    line-height: 26px;
  }

  .cop_add {
    height: 26px;
  }

  .cop_add .flex_center {
    height: 26px;
  }

  .cop_del_ic,
  .cop_add_ic {
    width: 15px;
    height: 15px;
    background-size: 6px;
    margin-right: 6px;
  }

  .cop_cont_cont .item {
    height: 50px;
    padding: 0 15px;
    font-size: 16px;
    line-height: 18px;
  }

  .cop_cont_cont .list.title .item:not(:first-child) {
    padding: 15px 14px;
  }

  .cop_cont_cont .list.content.last {
    width: 176px;
  }

  .line_2 .c_d_tag {
    width: 162px;
  }

  .c_d_tag .el-tag {
    height: 16px;
    line-height: 16px;
    border-radius: 5px;
    font-size: 12px;
  }

  .btn_box {
    margin-top: 20px;
  }

  .btn_return {
    width: 94px;
    height: 26px;
    line-height: 26px;
    border-radius: 7px;
    font-size: 12px;
  }

  .create_item_lab {
    font-size: 12px;
    margin-bottom: 5px;
  }

  .create_inpt {
    height: 30px;
    border-radius: 7px;
    font-size: 12px;
    padding: 9px 14px;
    margin-bottom: 14px;
  }

  .btn_view {
    padding: 5px 4px;
    border-radius: 7px;
    height: 22px;
    line-height: 14px;
    font-size: 12px;
  }

  .btn_view + .btn_view {
    margin-left: 5px;
  }

  .ser_icon {
    width: 40px;
    height: 26px;
  }

  .btn_gray,
  .btn_blue {
    width: 94px;
    height: 22px;
    line-height: 22px;
    border-radius: 7px;
    font-size: 12px;
  }

  .btn_gray {
    margin-left: 7px;
  }

  .btn_blue img {
    width: 12px;
    height: 12px;
    margin-right: 4px;
  }

  .el-radio__inner {
    width: 14px;
    height: 14px;
  }

  .head_search {
    height: 40px;
    border-radius: 7px;
  }

  .search_input {
    line-height: 16px;
    font-size: 14px;
  }

  .search_btn {
    width: 15px;
    height: 15px;
    margin-left: 7px;
    margin-right: 7px;
  }

  .search_btn img {
    width: 16px;
  }

  .search_left {
    width: 158px;
  }

  .search_left::after {
    top: 7px;
    height: 22px;
  }

  .search_left /deep/ .el-input__inner {
    font-size: 12px;
  }

  .country_flag_img {
    width: 34px;
    height: 22px;
    margin: 9px 0 9px 4px;
  }

  .sel_value {
    width: 42px;
    font-size: 12px;
  }

  .search_left .el-select {
    width: 160px;
  }

  .search_left /deep/ .el-select .el-input__inner {
    height: 38px;
    font-size: 14px;
    line-height: 16px;
  }

  .search_left.on /deep/ .el-select .el-input__inner {
    padding-left: 40px;
  }

  .sel_place {
    line-height: 34px;
    padding-left: 14px;
    font-size: 12px;
  }

  .el-select-dropdown__wrap {
    max-height: 248px !important;
  }

  .el-select-dropdown__list {
    padding: 7px 0 !important;
  }

  .search_sel_container {
    width: 790px;
  }

  .head_swi_keyword .el-switch,
  .head_login .el-switch {
    height: 22px;
    line-height: 22px;
  }

  .head_swi_keyword /deep/ .el-switch__core,
  .head_login /deep/ .el-switch__core {
    width: 64px !important;
    height: 22px;
    border-radius: 11px;
  }

  .head_swi_keyword /deep/ .el-switch__core {
    width: 66px !important;
  }

  .head_swi_keyword /deep/ .el-switch__core:after,
  .head_login /deep/ .el-switch__core:after {
    width: 18px;
    height: 18px;
  }

  .head_swi_keyword /deep/ .el-switch.is-checked .el-switch__core::after {
    left: 58px;
  }

  .search_sel_container .right {
    width: 632px;
    max-height: 224px;
    padding: 0 5px;
  }

  .search_sel_container /deep/ .el-tabs--left .el-tabs__item.is-left {
    height: 28px;
    margin-bottom: 5px;
    padding: 0 7px !important;
  }

  .search_sel_container .left_txt {
    font-size: 14px;
    margin-right: 7px;
  }

  .search_sel_container .right .el-select-dropdown__item {
    width: 148px;
    height: 38px;
    padding: 0 7px;
  }

  .search_sel_container .right .img {
    width: 36px;
  }

  .search_sel_container .right .rBox .coun_title {
    font-size: 12px;
    max-width: 94px;
  }

  .table_box /deep/ .el-table {
    height: 552px;
  }

  .table_box /deep/ .el-table th > .cell,
  .table_box /deep/ td.el-table__cell > .cell {
    padding-right: 7px;
    font-size: 16px;
    line-height: 16px;
    padding: 0 7px;
  }

  .table_box /deep/ .el-table--border .el-table__cell:first-child .cell {
    padding-left: 15px !important;
  }

  .table_box /deep/ th.el-table__cell {
    height: 44px;
  }

  .table_box /deep/ .el-table thead {
    height: 44px !important;
  }

  .table_box /deep/ td.el-table__cell {
    height: 50px !important;
  }

  .table_box .el-table__row .company img {
    width: 30px;
    height: 22px;
    margin-right: 4px;
  }

  .tbl_company {
    line-height: 24px;
  }

  .CompanyNameActive {
    font-size: 16px;
    line-height: 22px;
  }

  .CompanyNameActive .icon {
    width: 15px;
    height: 15px;
    margin-right: 7px;
  }

  .item_active {
    height: 106px !important;
  }

  .list:not(:first-child) .item_active {
    font-size: 16px;
    line-height: 20px;
  }

  .Deletepostion {
    top: 7px;
    right: 7px;
  }

  .Deletepostion .icon {
    width: 15px;
    height: 15px;
  }

  .Deletepostionleft {
    width: 170px;
    height: 30px;
    border-radius: 0px 0px 15px 0px;
    font-size: 16px;
    line-height: 18px;
  }

  .Deletepostionleft .icon {
    width: 15px;
    height: 15px;
    margin: 0 6px 0 10px;
  }
  ::v-deep .dialog_normal2,
  ::v-deep .dialog_normalmengent {
    width: 1200px !important;
  }

  .country-dropdown,
  .trade-dropdown {
    width: 160px;
    min-width: 160px;
    border-radius: 20px 0 0 20px;
  }

  .country-dropdown::after,
  .trade-dropdown::after {
    height: 22px;
  }

  .select-country-con {
    padding: 0 10px 0 15px;
  }

  .select-country-con .country-placeholder {
    font-size: 14px;
  }

  .select-country-img {
    width: 22px;
    height: 14px;
    margin-right: 4px;
  }

  .select-country-name {
    margin-right: 2px;
    line-height: 16px;
    font-size: 14px;
  }

  .trade-dropdown .select-country-name {
    font-size: 14px;
  }

  .u942df .iconfont {
    font-size: 20px;
  }

  .country-popper {
    top: 46px;
    width: 750px;
    height: 200px;
    padding: 10px 3px 10px 0;
    border-radius: 4px;
  }

  .country-show-popper {
    width: 850px;
    height: 264px;
  }

  .country-popper-arrow {
    left: 35px;
    top: -6px;
    border-width: 6px;
    border-top-width: 0;
    border-bottom-color: #ffffff;
  }

  .country-popper-arrow::after {
    border-width: 8px;
  }

  .country-popper-con .state-con {
    width: 218px;
    height: 100%;
  }

  .country-popper-con .country-state-item {
    height: 40px;
    padding: 0 14px;
  }

  .country-popper-con .country-state-item:not(:last-child) {
    margin-bottom: 0px;
  }

  .country-popper-con .country-name {
    line-height: 14px;
    font-size: 14px;
  }

  .country-popper-con .country-countryCount {
    flex-shrink: 0;
    width: 20px;
    font-size: 12px;
  }

  .country-popper-con .state-country-con {
    width: 640px;
    padding-left: 10px;
  }

  .country-popper-con .state-country-item {
    width: 148px;
    height: 40px;
    padding: 4px 6px;
    margin-bottom: 6px;
  }

  .country-popper-con .state-country-item:not(:nth-child(4n)) {
    margin-right: 6px;
  }

  .country-popper-con .state-country-item img {
    width: 38px;
    height: 22px;
    margin-right: 4px;
  }

  .country-popper-con .state-country-name {
    line-height: 14px;
    margin-bottom: 2px;
    font-size: 14px;
  }

  .country-popper-con .state-country-companyCount {
    font-size: 12px;
  }
}

@media screen and (max-width: 1439px) {
  .country_img img {
    width: 26px;
    height: 18px;
  }

  .create_item /deep/ .el-input__inner {
    height: 24px;
    border-radius: 5px;
  }

  .country_sel /deep/ .el-input__inner {
    padding-left: 32px;
  }

  .create_item /deep/ .el-autocomplete .el-input__inner {
    background-size: 12px;
    padding-right: 34px;
  }

  .create_item {
    margin-bottom: 12px;
  }

  .cop_title {
    margin-top: 3px;
    margin-bottom: 20px;
    margin-left: 12px;
    font-size: 14px;
    line-height: 18px;
  }

  .cop_title .icon {
    width: 18px;
    height: 16px;
    margin-right: 14px;
  }

  .cop_cont_head {
    height: 24px;
    font-size: 12px;
  }

  .cop_company {
    line-height: 22px;
  }

  .cop_add {
    height: 24px;
  }

  .cop_add .flex_center {
    height: 24px;
  }

  .cop_del_ic,
  .cop_add_ic {
    width: 12px;
    height: 12px;
    background-size: 5px;
    margin-right: 5px;
  }

  .cop_cont_cont .item {
    height: 40px;
    padding: 0 12px;
    font-size: 14px;
    line-height: 14px;
  }

  .cop_cont_cont .list.title .item:not(:first-child) {
    padding: 12px;
  }

  .cop_cont_cont .list.content.last {
    width: 156px;
  }

  .line_2 .c_d_tag {
    width: 144px;
  }

  .c_d_tag .el-tag {
    height: 16px;
    line-height: 16px;
    border-radius: 5px;
    font-size: 12px;
  }

  .btn_box {
    margin-top: 18px;
  }

  .btn_return {
    width: 84px;
    height: 24px;
    line-height: 24px;
    border-radius: 6px;
    font-size: 12px;
  }

  .create_item_lab {
    font-size: 12px;
    margin-bottom: 5px;
  }

  .create_inpt {
    height: 26px;
    border-radius: 6px;
    font-size: 12px;
    padding: 8px 12px;
    margin-bottom: 12px;
  }

  .btn_view {
    padding: 5px 3px;
    border-radius: 6px;
    height: 20px;
    line-height: 16px;
    font-size: 12px;
  }

  .btn_view + .btn_view {
    margin-left: 5px;
  }

  .ser_icon {
    width: 34px;
    height: 24px;
  }

  .btn_gray,
  .btn_blue {
    width: 84px;
    height: 20px;
    line-height: 20px;
    border-radius: 6px;
    font-size: 12px;
  }

  .btn_gray {
    margin-left: 6px;
  }

  .btn_blue img {
    width: 10px;
    height: 10px;
    margin-right: 3px;
  }

  .el-radio__inner {
    width: 12px;
    height: 12px;
  }

  .head_search {
    height: 36px;
    border-radius: 6px;
  }

  .search_input {
    line-height: 16px;
    font-size: 14px;
  }

  .search_btn {
    width: 15px;
    height: 15px;
    margin-left: 6px;
    margin-right: 6px;
  }

  .search_btn img {
    width: 14px;
  }

  .search_left {
    width: 140px;
  }

  .search_left::after {
    top: 6px;
    height: 20px;
  }

  .search_left /deep/ .el-input__inner {
    font-size: 12px;
  }

  .country_flag_img {
    width: 30px;
    height: 20px;
    margin: 8px 0 8px 3px;
  }

  .sel_value {
    width: 38px;
    font-size: 12px;
  }

  .search_left .el-select {
    width: 144px;
  }

  .search_left /deep/ .el-select .el-input__inner {
    height: 34px;
    font-size: 14px;
    line-height: 16px;
  }

  .search_left.on /deep/ .el-select .el-input__inner {
    padding-left: 34px;
  }

  .sel_place {
    line-height: 30px;
    padding-left: 12px;
    font-size: 12px;
  }

  .el-select-dropdown__wrap {
    max-height: 220px !important;
  }

  .el-select-dropdown__list {
    padding: 6px 0 !important;
  }

  .search_sel_container {
    width: 706px;
  }

  .head_swi_keyword .el-switch,
  .head_login .el-switch {
    height: 20px;
    line-height: 20px;
  }

  .head_swi_keyword /deep/ .el-switch__core,
  .head_login /deep/ .el-switch__core {
    width: 58px !important;
    height: 20px;
    border-radius: 10px;
  }

  .head_swi_keyword /deep/ .el-switch__core {
    width: 60px !important;
  }

  .head_swi_keyword /deep/ .el-switch__core:after,
  .head_login /deep/ .el-switch__core:after {
    width: 16px;
    height: 16px;
  }

  .head_swi_keyword /deep/ .el-switch.is-checked .el-switch__core::after {
    left: 50px;
  }

  .search_sel_container .right {
    width: 564px;
    max-height: 200px;
    padding: 0 5px;
  }

  .search_sel_container /deep/ .el-tabs--left .el-tabs__item.is-left {
    height: 26px;
    margin-bottom: 5px;
    padding: 0 6px !important;
  }

  .search_sel_container .left_txt {
    font-size: 14px;
    margin-right: 6px;
  }

  .search_sel_container .right .el-select-dropdown__item {
    width: 132px;
    height: 32px;
    padding: 0 6px;
  }

  .search_sel_container .right .img {
    width: 32px;
  }

  .search_sel_container .right .rBox .coun_title {
    font-size: 12px;
    max-width: 84px;
  }

  .table_box /deep/ .el-table {
    height: 492px;
  }

  .table_box /deep/ .el-table th > .cell,
  .table_box /deep/ td.el-table__cell > .cell {
    padding-right: 6px;
    font-size: 14px;
    line-height: 16px;
    padding: 0 6px;
  }

  .table_box /deep/ .el-table--border .el-table__cell:first-child .cell {
    padding-left: 12px !important;
  }

  .table_box /deep/ th.el-table__cell {
    height: 32px;
  }

  .table_box /deep/ .el-table thead {
    height: 32px !important;
  }

  .table_box /deep/ td.el-table__cell {
    height: 40px;
  }

  .table_box .el-table__row .company img {
    float: left;
    width: 26px;
    height: 20px;
    flex: none;
    margin-right: 3px;
  }

  .tbl_company {
    line-height: 22px;
  }

  .CompanyNameActive {
    font-size: 14px;
    line-height: 20px;
  }

  .CompanyNameActive .icon {
    width: 12px;
    height: 12px;
    margin-right: 6px;
  }

  .item_active {
    height: 94px !important;
  }

  .list:not(:first-child) .item_active {
    font-size: 14px;
    line-height: 18px;
  }

  .Deletepostion {
    top: 6px;
    right: 6px;
  }

  .Deletepostion .icon {
    width: 12px;
    height: 12px;
  }

  .Deletepostionleft {
    width: 150px;
    height: 26px;
    border-radius: 0px 0px 12px 0px;
    font-size: 14px;
    line-height: 16px;
  }

  .Deletepostionleft .icon {
    width: 12px;
    height: 12px;
    margin: 0 5px 0 6px;
  }
  ::v-deep .dialog_normal2,
  ::v-deep .dialog_normalmengent {
    width: 1000px !important;
  }
}
</style>
